export const counter = {
  cartsCount: 'Total Draft Orders',
  cartsValue: 'Value Draft Orders',
  quotesCount: 'Total Open Quotes',
  quotesValue: 'Value Open Quotes',
};
export const customer = {
  context: {
    set: 'Customer context has been set successfully.',
    remove: 'Customer context has been removed successfully.',
    required: 'Please select a Division to continue.',
    changeCustomerMessage: 'Do you want to change customer?',
    changeCustomerLabel: 'Change Customer?',
  },
  label: {
    heading: 'Customers Search',
    name: 'Account Name',
    number: 'Account Number',
    street: 'Street',
    country: 'Country',
    state: 'State/Province',
    stateLine1: 'State/',
    stateLine2: 'Province',
    selectState: 'Select State/Province',
    city: 'City',
    zipCode: 'Zip Code',
    phoneNo: 'Phone No.',
    noCustomerFound: 'No Customer Found',
    downloadCustomerList: 'Customer List',
    salesArea: 'Division',
    selectSalesArea: 'Select Division',
    selectSalesAreaFirst: "Please select a Division to continue."
  },
  recentCustomer: {
    heading: 'Recent Customers',
    name: 'Name',
    state: 'State/Province',
    city: 'City',
  },
};
export const quicklinks = {
  label: {
    heading: 'Quick Links',
  },
};

export const knbrHome = { counter, customer, quicklinks };
